import { render, staticRenderFns } from "./canada-performance-and-portfolio-panel.vue?vue&type=template&id=305f2919&"
var script = {}
import style0 from "./canada-performance-and-portfolio.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports